import React from 'react';
import { TopBanner } from '../components/TopBanner';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { MapPinIcon } from 'lucide-react';
export function Coverage() {
  return <div className="min-h-screen bg-white dark:bg-[#000000] text-[#333333] dark:text-gray-100 transition-colors duration-300" data-id="element-584" data-mp="3st4plwx5355r">
      <TopBanner data-id="element-585" data-mp="3nvd019jyvv4q" />
      <Navbar data-id="element-586" data-mp="pbmrih765cij" />
      <main className="pt-[133px]" data-id="element-587" data-mp="pc4mzbm0bmpe">
        <div className="py-20 text-center bg-[#13E200] dark:bg-[#090D1A]" data-id="element-588" data-mp="pb3ad2pces5k">
          <h1 className="text-5xl font-black tracking-tighter text-black dark:text-white uppercase mb-4" data-id="element-589" data-mp="kc9ytftm9b81">
            Network Coverage
          </h1>
          <p className="text-xl text-black/80 dark:text-gray-300 font-bold max-w-2xl mx-auto" data-id="element-590" data-mp="fjql8iuxig38">
            Unbroken 5G connectivity across the US and Canada.
          </p>
        </div>

        <section className="py-20 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-591" data-mp="183fbjm49fne4">
          <div className="w-24 h-24 bg-[#13E200]/10 rounded-full flex items-center justify-center mx-auto mb-8 border-2 border-[#13E200]/30" data-id="element-592" data-mp="139t9sozmx3x3">
            <MapPinIcon className="w-12 h-12 text-[#13E200]" data-id="element-593" data-mp="24vcz8ls5j2sy" />
          </div>
          <h2 className="text-3xl font-black text-black dark:text-white uppercase mb-6" data-id="element-594" data-mp="24xh7ffx32nz1">
            Nationwide Presence
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-400 mb-12 leading-relaxed" data-id="element-595" data-mp="1w2j6bljs84wm">
            Effy Mobile routes your talk, text, and 5G data over native nationwide VoLTE cellular towers. We provide seamless, high-speed coverage across the entire United States and Canada, ensuring your business stays connected no matter where your team is located.
          </p>
          
          <div className="bg-gray-50 dark:bg-[#0E131F] p-8 rounded-3xl border-2 border-gray-200 dark:border-white/10" data-id="element-596" data-mp="1d46utt5eeixv">
            <h3 className="text-xl font-black text-black dark:text-white uppercase mb-4" data-id="element-597" data-mp="32ilfo2daplo3">Check Your Zip Code</h3>
            <div className="flex max-w-md mx-auto relative" data-id="element-598" data-mp="37h6im9jxmjg8">
              <input type="text" placeholder="Enter Zip Code" className="w-full bg-white dark:bg-black border-2 border-black dark:border-white/20 rounded-full py-4 px-6 text-sm font-bold text-black dark:text-white focus:outline-none focus:ring-4 focus:ring-[#13E200]/20 transition-all" data-id="element-599" data-mp="353kwztvdizvr" />
              <button className="absolute right-2 top-2 bottom-2 bg-[#13E200] text-black px-6 rounded-full font-black uppercase tracking-widest text-xs hover:bg-[#00A86B] transition-colors" data-id="element-600" data-mp="2r5cruyo6os9i">
                Check
              </button>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-601" data-mp="3f0fqfycsia36" />
    </div>;
}